var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnLeftSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 4.998 9.062",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.137 4.172 4.172.137a.488.488 0 0 1 .689.69L1.156 4.53l3.705 3.705a.488.488 0 0 1-.69.69L.138 4.89A.48.48 0 0 1 0 4.53a.47.47 0 0 1 .136-.357"
})));
export default SvgBtnLeftSmall;